import { render, staticRenderFns } from "./SsuInfo.vue?vue&type=template&id=38d485ef&scoped=true"
import script from "./SsuInfo.vue?vue&type=script&lang=js"
export * from "./SsuInfo.vue?vue&type=script&lang=js"
import style0 from "./SsuInfo.vue?vue&type=style&index=0&id=38d485ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d485ef",
  null
  
)

export default component.exports